<template>
  <div>
    <div style="height: 100px"></div>

    <div class="service-bg animate__animated animate__backInLeft">
      <img src="../assets/img/contact-bg.jpg" alt />
      <div class="common">
        <div class="service-title" style="text-align: left">
          <div class="service-title-top" >联系我们</div>
          <div class="service-title-bottom">Contact</div>
        </div>
      </div>
    </div>
    <div class="connect-cont animate__animated animate__backInLeft">
      <div class="common connect-cont-box">
        <div class="connect-cont-left">
          <ul class="connect-cont-left-ul">
            <li>重庆中讯亚太信息技术有限公司</li>
            <li>联系电话：023-67030166</li>
            <li>
              Email:
              <span style="color: #4774b6">office@cqzxyatai.com</span>
            </li>
            <li>联系地址：重庆市南岸区复兴街9号中讯时代6楼</li>
            <li>备案号：渝ICP备2021001555号-1</li>
          </ul>
        </div>
        <div class="connect-cont-right">
          <baidu-map
            class="bm-view"
            :center="center"
            :zoom="zoom"
            @ready="init"
          ></baidu-map>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      center: {
        lng: 109.45744048529967,
        lat: 36.49771311230842,
      },
      zoom: 13,
      mapData: [],
      people: [
        {
          lng: 109.45744048529967,
          lat: 36.49771311230842,
          type: "people",
          orderNum: 5,
        },
        {
          lng: 110.45744048529967,
          lat: 35.49771311230842,
          type: "people",
          orderNum: 3,
        },
      ],
      orders: [
        {
          lng: 109.75744048529967,
          lat: 36.49771311230842,
          type: "order",
          stayTime: "12",
        },
        {
          lng: 109.45744048529967,
          lat: 36.89771311230842,
          type: "order",
          stayTime: "3",
        },
      ],
      tabList: [
        {
          name: "全部显示",
          type: "all",
        },
        {
          name: "仅显示人员",
          type: "people",
        },
        {
          name: "仅显示订单",
          type: "order",
        },
      ],
      currentTab: "all",
      map: null,
      infoBox: null,
      content: "",
      opts: null,
    };
  },
  methods: {
    handleToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },

    init({ BMap, map }) {
      this.map = map;
      // 初始化地图,设置中心点坐标
      var point = new BMap.Point(106.591773, 29.594548);
      map.centerAndZoom(point, 14);
      //this.setMarker();
      // 添加鼠标滚动缩放
      map.enableScrollWheelZoom();
      map.centerAndZoom(point, 15);
      // 创建点标记
      var marker = new BMap.Marker(point);
      map.addOverlay(marker);
    },
  },
  mounted() {
    this.handleToTop();
  },
};
</script>

<style scoped>
.bm-view {
  width: 100%;
  height: 600px;
}
.service-bg {
  height: 450px;
  width: 100%;
  position: relative;
}
.service-bg img {
  width: 100%;
  height: 100%;
}
.service-title {
  position: relative;
  height: 190px;
  width: 1500px;
  background-color: #fff;
  position: absolute;
  bottom: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-content: center;
  padding-left: 30px;
}
.service-title-top {
  font-size: 38px;
  line-height: 58px;
  font-weight: 800;
}
.service-title-bottom {
  color: #707070;
  font-size: 28px;
}
.connect-cont {
  height: 900px;
  background-color: #f7f8ff;
  padding-top: 100px;
}
.connect-cont-box {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.connect-cont-left {
  padding: 30px;
  background-color: #fff;
}
.connect-cont-left-ul {
  text-align: left;
  font-size: 20px;
  line-height: 40px;
}
.connect-cont-left-ul li:nth-child(1) {
  font-size: 20px;
  font-weight: 600;
  line-height: 40px;
  margin-bottom: 20px;
}
.connect-cont-right {
  width: 900px;
  height: 600px;
  margin: auto;
  background-color: #aaaa;
}
.connect-cont-right img {
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 1500px) {
  .service-title {
    height: 190px;
    width: 1000px;
  }
  .service-menu-box {
    width: 900px;
  }
  .service-menu-item {
    width: 240px;
    font-size: 22px;
  }
  .service-menu {
    height: 100px;
    padding-top: 10px;
  }
  .connect-cont {
    height: 800px;
    padding-top: 80px;
  }
  .connect-cont-left-ul {
    font-size: 18px;
    line-height: 60px;
  }
  .connect-cont-right {
    width: 90%;
    height: 500px;
    margin: auto;
    background-color: #aaaa;
  }
}
</style>